import { api } from './api';
import type { Provider } from '@/types/api';

export async function generateSuggestions(params: {
  provider: Provider;
  last_user_message: string;
  last_assistant_msg: string;
}): Promise<string[]> {
  try {
    const { data } = await api.post<{ suggestions: string[] }>(
      '/api/v1/suggestions',
      params,
      // Suggestions are a polish feature — if the endpoint hiccups we
      // don't want to block the UI waiting. 8s cap matches the backend
      // timeout (10s) with a margin.
      { timeout: 8_000 },
    );
    return data.suggestions ?? [];
  } catch {
    // Silent failure: no chips is a valid state.
    return [];
  }
}
